import { render, staticRenderFns } from "./HotCommentList.vue?vue&type=template&id=4892c6df&"
import script from "./HotCommentList.vue?vue&type=script&lang=js&"
export * from "./HotCommentList.vue?vue&type=script&lang=js&"
import style0 from "./HotCommentList.vue?vue&type=style&index=0&id=4892c6df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports